import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Organization } from './models/organizations';
import { OrganizationService } from './organizations.service';

@Injectable()
export class OrganizationsDefaultImplementationService extends OrganizationService {
    getOrganizations(): Observable<Organization[]> {
        return of([]);
    }

    getOrganizationById(id: string): Observable<Organization | undefined> {
        return of(undefined);
    }
}
